var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFindUsPin = function SvgFindUsPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "112px",
    viewBox: "0 0 74 112",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_Pin")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.5%",
    y: "-33.3%",
    width: "105.1%",
    height: "176.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.49999988,
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Homepage",
    transform: "translate(-683.000000, -7681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Locations_Section",
    transform: "translate(120.000000, 7468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map",
    transform: "translate(0.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_Pin",
    transform: "translate(552.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8249992,88.6684594 C42.061441,84.8623625 54.2385565,84.8623625 65.4749983,88.6684594 C69.7763331,90.1254417 72.0821364,94.7934801 70.625154,99.0948149 C69.9797608,101.000159 68.6583042,102.60282 66.9108727,103.59949 L48.1499987,114.299998 L48.1499987,114.299998 L29.3891248,103.59949 C25.4442792,101.349496 24.0703305,96.3275863 26.3203243,92.3827408 C27.3169946,90.6353093 28.9196552,89.3138527 30.8249992,88.6684594 Z",
    id: "shadow",
    fill: "#747474",
    filter: "url(#filter-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0749994,21.2941321 C37.8221014,9.13493729 58.477896,9.13493729 72.2249981,21.2941321 C86.0082328,33.4852859 88.640836,53.9953618 78.3833123,69.2723052 L48.1499987,114.299997 L48.1499987,114.299997 L17.9166852,69.2723052 C7.65916145,53.9953618 10.2917646,33.4852859 24.0749994,21.2941321 Z",
    id: "bg",
    fill: "#002147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5999993,26.0999993 L48.5999993,37.2823637 L37.259999,37.2823637 L37.259999,48.5549085 L48.5999993,48.5549085 L48.5999993,59.8274533 L42.9299989,59.8274533 C33.6350391,59.8274533 26.0999993,52.2773132 26.0999993,42.9637263 C26.0999993,33.6501394 33.6350391,26.0999993 42.9299989,26.0999993 L48.5999993,26.0999993 Z M48.5999987,37.2823637 L54.2249986,37.2823637 C63.5447983,37.2823637 71.0999987,44.8527042 71.0999987,54.1911809 C71.0999987,63.5296576 63.5447983,71.0999981 54.2249986,71.0999981 L48.5999987,71.0999981 L48.5999987,59.8274533 L59.9399984,59.8274533 L59.9399984,48.5549085 L48.5999987,48.5549085 L48.5999987,37.2823637 Z",
    id: "logo",
    fill: "#FFFFFF"
  }))))))));
};
export default SvgFindUsPin;